'use client';

import Link from 'next/link';
import { cn } from '@/lib/utils';

interface TextLinkProps {
    href: string;
    children: React.ReactNode;
    className?: string;
    ariaLabel?: string;
    title?: string;
    rel?: string;
}

export function TextLink({ href, children, className, ariaLabel, title, rel }: TextLinkProps) {
    // Determine if link is external
    const isExternal = href.startsWith('http') || href.startsWith('//');
    const linkRel = rel || (isExternal ? 'noopener noreferrer' : undefined);

    // Generate aria-label from children if not provided
    const ariaLabelValue = ariaLabel || (typeof children === 'string' ? children : undefined);

    return (
        <Link
            href={href}
            className={cn(
                'inline-flex items-center gap-1 text-smpy-2 font-medium text-primary-600 dark:text-primary-400 hover:gap-2 transition-all duration-300 group/link',
                className
            )}
            aria-label={ariaLabelValue}
            title={title || (typeof children === 'string' ? children : undefined)}
            rel={linkRel}
            {...(isExternal && { target: '_blank' })}
        >
            {children}
            <span
                aria-hidden="true"
                className="opacity-0 group-hover/link:opacity-100 translate-x-0 group-hover/link:translate-x-0.5 transition-all duration-300"
            >
                →
            </span>
        </Link>
    );
}

